import { useState } from 'react';

import { CheckboxGroupItem } from './CheckboxGroup';

export function useCheckboxGroupValue(initialValue: CheckboxGroupItem[] = []) {
  const [value, setValue] = useState(initialValue);

  const toggle = (item: CheckboxGroupItem) => {
    // is checked
    if (value.find((item_) => item_.value === item.value)) {
      setValue(
        (current) => current.filter((item_) => item_.value !== item.value), // remove from checked items
      );
    } else {
      setValue(
        (current) => [...current, item], // add it value
      );
    }
  };

  const reset = () => {
    setValue([]);
  };

  return [value, toggle, reset] as const;
}
